import { render, staticRenderFns } from "./extra-breadcrumb.vue?vue&type=template&id=0e42bf67&lang=pug&"
import script from "./extra-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./extra-breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports